export const surgicalTeamsConstants = {
  GETSUGICALTEAMS_REQUEST: 'GETSUGICALTEAMS_REQUEST',
  GETSUGICALTEAMS_SUCCESS: 'GETSUGICALTEAMS_SUCCESS',
  GETSUGICALTEAMS_FAILURE: 'GETSUGICALTEAMS_FAILURE',
};
